import type { CopiedBoardSummary } from '@atlassian/jira-boards-common/src/model/index.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';

const copyBoard = (boardId: string): Promise<CopiedBoardSummary> => {
	const url = `/rest/greenhopper/1.0/rapidview/${boardId}/copy`;
	const options = {
		method: 'PUT',
	};
	return fetchJson(url, options);
};

export default copyBoard;
